import React from 'react'
import PropTypes from 'prop-types'
import AnimateHeight from 'react-animate-height'
import { colors } from '@lmc/common/constants'
import { Icon } from '../../../../components/generic'
import CarePlanReportsItem from './CarePlanReportsItem'
import { getNominative } from '../../../../common/utils'
import { EmptyState, NoDataIcon, Icon as UiKitIcon } from '@lmc/ui-kit'
import _ from 'lodash'

export default class CarePlanReportsSection extends React.Component {
  state = {
    isOpen: true
  }

  hasCarePlans = () => !!Object.keys(this.props.carePlans).length

  toggleOpen = () =>
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }))

  renderHeader = (title) => (
    <div style={styles.headerContainer}>
      <div style={styles.titleContainer}>
        <h2 style={styles.title}>{title}</h2>
        <div
          className="toggle-section-open"
          onClick={this.toggleOpen}
          style={styles.toggleContainer}
        >
          <UiKitIcon
            name={this.state.isOpen ? 'UpOutlined' : 'DownOutlined'}
            size="small"
            style={styles.toggle}
          />
        </div>
      </div>
    </div>
  )

  renderCarePlans = () => {
    const { carePlans } = this.props

    const residentNames = Object.keys(carePlans).sort()

    const sortedResidentNames = _.sortBy(residentNames, (option) => {
      return carePlans[option]?.[0]?.resident?.name?.first
    })

    return (
      <div>
        {sortedResidentNames.map((name) => (
          <div key={name} style={styles.carePlansContainer}>
            <CarePlanReportsItem carePlans={carePlans[name]} />
          </div>
        ))}
      </div>
    )
  }

  renderEmpty = () => {
    const { showSuccess, carePlanNominative } = this.props

    if (showSuccess) {
      return (
        <div style={styles.successContainer}>
          <Icon
            fill={colors.green}
            name="tick-in-circle"
            size={80}
            style={styles.successIcon}
          />
          <span>{getSuccessMessage(carePlanNominative)}</span>
        </div>
      )
    }

    return (
      <EmptyState
        title={getEmptyMessage(carePlanNominative)}
        icon={<NoDataIcon />}
      />
    )
  }

  render() {
    const { carePlans, style, title } = this.props
    if (!carePlans || !title) return null
    return (
      <div style={style}>
        {this.renderHeader(title)}
        <AnimateHeight
          animateOpacity={true}
          duration={500}
          height={this.state.isOpen ? 'auto' : 0}
        >
          {this.hasCarePlans() ? this.renderCarePlans() : this.renderEmpty()}
        </AnimateHeight>
      </div>
    )
  }
}

const getEmptyMessage = (carePlanNominative) =>
  `No upcoming ${getNominative(carePlanNominative, 'Care Plan')} reviews`
const getSuccessMessage = (carePlanNominative) =>
  `Woo! You're up to date on all the ${getNominative(
    carePlanNominative,
    'Care Plans'
  )}`
const styles = {
  carePlansContainer: {
    paddingBottom: 5
  },
  divider: {
    height: 2,
    marginBottom: 10,
    width: '100%'
  },
  headerContainer: {
    width: '100%'
  },
  successContainer: {
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 600,
    display: 'flex',
    width: '100%'
  },
  successIcon: {
    marginRight: 24
  },
  titleContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  toggle: {
    fontSize: 24
  },
  toggleContainer: {
    cursor: 'pointer',
    padding: '8px 15px 0px 15px'
  },
  title: {
    marginBottom: '0.3em',
    textOverflow: 'ellipsis',
    hyphens: 'auto'
  }
}

CarePlanReportsSection.propTypes = {
  carePlans: PropTypes.object.isRequired,
  showSuccess: PropTypes.bool,
  style: PropTypes.object,
  title: PropTypes.string.isRequired
}
